import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectPermissionsByPath } from "../../store/user/user-selector";
import { permissionKeys } from "../../store/globalSettings";

export const useAccessControl = () => {
  const { pathname } = useLocation();
  const LoggedInUserRoleKey = useSelector((state) => state.user?.user?.roleKey);

  // This will only re-run if pathname changes or Redux state changes
  const permissions = useSelector((state) =>
    selectPermissionsByPath(state, pathname),
  );

  const isSysAdmin = LoggedInUserRoleKey === "SysAdmin";

  const hasPermission = (action) => {
    if (isSysAdmin) return true;

    return permissions.has(action);
  };

  return {
    permissions, // This is the Set
    hasPermission,
    isEmpty: permissions.size === 0,
    isAdd: hasPermission(permissionKeys.add),
    isEdit: hasPermission(permissionKeys.edit),
    isDelete: hasPermission(permissionKeys.delete),
    isView: hasPermission(permissionKeys.view),
    isViewSetting: hasPermission("ViewSetting"),
    isEditSetting: hasPermission("EditSetting"),
  };
};
